import * as React from 'react';
import { observer } from 'mobx-react';
import styled, { withTheme } from 'styled-components';
import { propStyles } from '@kurtosys/ksys-portal-components/build/utils/propStyles';
import Icon from './Icon';
import Translate from './Translate';

const Label = styled<any, any>('label') `
    ${propStyles};
    opacity: ${props => props.disabled ? 0.5 : 1};
    cursor: pointer;
`;

Label.defaultProps = {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    flex: "0 0 auto",
    paddingY: "xs",
    color: "body",
    hover: {
        color: "primary"
    },
    selected: {
        color: "primary"
    },
    alternated: {
        color: "gray500"
    }
};

export interface CheckboxProps {
    theme?: { [property: string]: string | number };
    label?: string;
    checked: boolean;
    disabled?: boolean;
    active?: boolean;
    onChange: React.ChangeEventHandler<HTMLInputElement>;
    checkedIconFileName?: string;
    uncheckedIconFileName?: string;
}

export const Checkbox: React.SFC<CheckboxProps> = ({ 
    theme, label, checked, disabled, active, onChange, checkedIconFileName = "CheckboxMarkedIcon", uncheckedIconFileName = "CheckboxIcon" 
}) => (
    <Label
        disabled={disabled}
        data-selected={checked}
        data-alternated={!active}
        {...theme.CheckboxLabel}
    >
        <input
            type="checkbox"
            defaultChecked={checked}
            onChange={onChange}
            disabled={disabled}
            style={{ display: 'none' }}
        />
        {
            checked 
            ? <Icon fileName={checkedIconFileName} {...theme.CheckboxChecked} /> 
            : <Icon fileName={uncheckedIconFileName} {...theme.CheckboxUnchecked} />
        }
        <Translate>{label}</Translate>
    </Label>
);

export default observer(withTheme(Checkbox));


// WEBPACK FOOTER //
// ./src/Components/Checkbox.tsx